import { PARTNERS } from 'config/app-config';
import { sessionStorageKeys, STORAGE } from 'config/storage-config';
import {
  findPartnerLanding,
  getSessionStoragePartner
} from 'utils/getSessionStoragePartner';

export const initPartner = () => {
  const matchedPartner = findPartnerLanding(window.location);
  const partnerLanding = matchedPartner || PARTNERS.DIRECT_SALES;
  // For browser back from DS journey to any previous partner page except landing page
  // restore partner from browser history saved before leaving the partner journey
  // See: useHistoryNavigation
  const historyStatePartnerName = window.history.state?.state?.partnerName;
  const shouldRestorePartner = !!historyStatePartnerName;

  // restore partner from sessionStorage if it exists. See useOnExit saving partner before exiting
  if (shouldRestorePartner) {
    STORAGE.setItem(
      sessionStorageKeys.PARTNER_PATH,
      historyStatePartnerName,
      false
    );
  }

  if (matchedPartner || !getSessionStoragePartner()) {
    STORAGE.setItem(sessionStorageKeys.PARTNER_PATH, partnerLanding, false);
  }
};
